"use strict";import{DialogBase as e}from"./src/DialogBase.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-dialog-base",e);
//# sourceMappingURL=sp-dialog-base.js.map
